import { useEffect } from "react";
import * as serviceWorkerRegistration from "../serviceWorkerRegistration";
import Brand from "../api/Brand";
import Color from "../modules/Color";

const HOST_URL = `${window.location.protocol}//${window.location.host}`;

const DEFAULT_MANIFEST = {
    short_name: "Bizapptor",
    name: "Bizapptor Application Center",
    icons: [
        {
            src: `${HOST_URL}/favicon.ico`,
            sizes: "64x64 32x32 24x24 16x16",
            type: "image/x-icon",
        },
        {
            src: `${HOST_URL}/logo192.png`,
            type: "image/png",
            sizes: "192x192",
        },
        {
            src: `${HOST_URL}/logo512.png`,
            type: "image/png",
            sizes: "512x512",
        },
    ],
    start_url: HOST_URL,
    display: "standalone",
    orientation: "portrait-primary",
    scope: HOST_URL,
    theme_color: "#000000",
    background_color: "#ffffff",
};

const useBrandUI = (brand?: Brand) => {
    useEffect(() => {
        if (!brand) return;

        const color = new Color(
            brand.colorRed,
            brand.colorGreen,
            brand.colorBlue
        );

        const colorHex = color.toHex();

        const manifest = {
            ...DEFAULT_MANIFEST,
            name: `${brand.name} ADMIN`,
            short_name: `${brand.name} ADMIN`.substring(0, 12),
            theme_color: colorHex,
            icons: [
                {
                    src: brand.favicon(64)!,
                    sizes: "64x64",
                    type: "image/png",
                },
                {
                    src: brand.favicon(192)!,
                    sizes: "192x192",
                    type: "image/png",
                },
                {
                    src: brand.favicon(512)!,
                    sizes: "512x512",
                    type: "image/png",
                },
            ],
        };

        // Inject manifest
        const content = encodeURIComponent(JSON.stringify(manifest));
        const url = `data:application/manifest+json,${content}`;
        let manifestLink = document.getElementById(
            "manifest-id"
        ) as HTMLLinkElement;
        if (!manifestLink) {
            manifestLink = document.createElement("link");
            manifestLink.id = "manifest-id";
            manifestLink.rel = "manifest";
            document.head.appendChild(manifestLink);
        }
        manifestLink.href = url;

        // Update Favicon
        let favicon = document.querySelector(
            "link[rel~='icon']"
        ) as HTMLLinkElement;
        if (!favicon) {
            favicon = document.createElement("link");
            favicon.rel = "icon";
            document.head.appendChild(favicon);
        }
        favicon.href = brand.favicon(64)!;

        // Add Apple Touch Icon
        let appleTouchIcon = document.querySelector(
            "link[rel='apple-touch-icon']"
        ) as HTMLLinkElement;
        if (!appleTouchIcon) {
            appleTouchIcon = document.createElement("link");
            appleTouchIcon.rel = "apple-touch-icon";
            document.head.appendChild(appleTouchIcon);
        }
        appleTouchIcon.href = brand.favicon(192)!;

        // Update theme-color meta tag (colors the status bar on mobile)
        let themeColorMeta = document.querySelector(
            "meta[name='theme-color']"
        ) as HTMLMetaElement;
        if (!themeColorMeta) {
            themeColorMeta = document.createElement("meta");
            themeColorMeta.name = "theme-color";
            document.head.appendChild(themeColorMeta);
        }
        themeColorMeta.content = colorHex;

        // Register SW
        console.log("[useBrandUI] Registering service worker");
        serviceWorkerRegistration.register();

        console.log("[useBrandUI] Initialized successfully");
    }, [brand]);
};

export default useBrandUI;
